/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { getStore } from './browser-store'
import {
  NO_BROWSER_STORAGE,
  INNER_STORE,
  ERROR_OBTAIN_ACCESS_TOKEN,
} from './constants'
import { put } from './inner-store'
import { toRedirect } from './to-redirect'
import { redirected } from './redirected'
import { authStates, defineState } from './define-state'
import { iAuthConfig, iAuthData } from './types'
import { thirdPartyAuthentication } from './third-party-auth'

export type iAuthInit = (params: iAuthConfig) => Promise<iAuthData>

const init: iAuthInit = async ({
  authServerLoginUri,
  authServerLogoutUri,
  authServerTokenUri,
  authServerTokenSSOUri,
  client_id,
  redirect_uri,
  scope,
  withState = false,
  additionalParams,
  autoRefresh = false,
  autoRefreshTime,
}) => {
  put(INNER_STORE.authServerLoginUri, authServerLoginUri)
  put(INNER_STORE.authServerLogoutUri, authServerLogoutUri)
  put(INNER_STORE.authServerTokenUri, authServerTokenUri)
  put(INNER_STORE.authServerTokenSSOUri, authServerTokenSSOUri)
  put(INNER_STORE.client_id, client_id)
  put(INNER_STORE.redirect_uri, redirect_uri)
  put(INNER_STORE.scope, scope)
  put(INNER_STORE.withState, withState)
  put(INNER_STORE.additionalParams, additionalParams)
  put(INNER_STORE.auth, {
    isAuthenticated: false,
  })
  put(INNER_STORE.autoRefresh, autoRefresh)
  put(INNER_STORE.autoRefreshTime, autoRefreshTime)

  // comprobar que se pueden almacenar datos en el navegador
  const browserStore = getStore()
  if (browserStore === null) throw new Error(NO_BROWSER_STORAGE)

  const appState = defineState()

  if (appState === authStates.NON_AUTHENTICATED) {
    await toRedirect({
      withState,
      browserStore,
      authServerLoginUri,
      client_id,
      redirect_uri,
      scope,
      additionalParams,
    })
  }

  let authData = {
    isAuthenticated: false,
  } as iAuthData

  if (appState === authStates.REDIRECTED) {
    try {
      const result = await redirected({
        browserStore,
        redirect_uri,
        client_id,
        scope,
        authServerTokenUri,
        autoRefresh,
      })
      authData = { ...{ isAuthenticated: true }, ...result }
    } catch (error) {
      console.error(ERROR_OBTAIN_ACCESS_TOKEN, error) // eslint-disable-line no-console
      throw error
    }
  }

  if (appState === authStates.THIRD_PARTY_AUTHENTICATION) {
    try {
      const result = await thirdPartyAuthentication({
        authServerTokenSSOUri,
        autoRefresh,
      })
      authData = { ...{ isAuthenticated: true }, ...result }
    } catch (error) {
      console.error(ERROR_OBTAIN_ACCESS_TOKEN, error) // eslint-disable-line no-console
      throw error
    }
  }

  return authData
}

export { init }
